export default {
  SET_GENERAL_ENUMS(state, enums) {
    state.generalEnums = enums
  },
  SET_ENUMS(state, enums) {
    state.enums = enums
  },
  SET_ENUMS_COUNT(state, count) {
    state.enumsCount = count
  }
}
